import { render } from "./AccountSettings.vue?vue&type=template&id=b85d2378&scoped=true"
import script from "./AccountSettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AccountSettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./AccountSettings.vue?vue&type=style&index=0&id=b85d2378&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b85d2378"]])

export default __exports__